import { ContactData } from '../../types';

const contactData: ContactData = {
  title: "Let's Get in Touch",
  intro: "Have a question or want to work with me? Send me a message and I will get back to you as soon as possible.",
  formLabels: {
    name: "Your Name",
    email: "Your Email",
    subject: "Subject",
    message: "Your Message",
    submit: "Send Message"
  },
  formPlaceholders: {
    name: "John Doe",
    email: "john@example.com",
    subject: "Project inquiry",
    message: "Tell me about your project or your request..."
  },
  contactInfo: {
    title: "Contact Information",
    email: {
      label: "Email",
      value: "kontakt@robinwichmann.com"
    },
    location: {
      label: "Location",
      value: "Bliedersdorf (near Hamburg, Germany)"
    },
    availability: {
      label: "Availability",
      value: "Monday – Friday, 9 am – 5 pm CET"
    },
    social: {
      title: "You can also find me on"
    },
    quickResponse: {
      title: "Need a quick response?",
      text: "Use the form and I will get back to you as soon as possible."
    },
    thankYou: {
      title: "Thank you for your interest",
      text: "I'm always excited about new projects and challenges!"
    }
  },
  socialLinks: [
    {
      name: "LinkedIn",
      url: "https://www.linkedin.com/in/robin-wichmann-a0078478/",
      icon: "linkedin"
    },
    {
      name: "GitHub",
      url: "https://github.com/Marvbuster",
      icon: "github"
    }
  ],
  successMessage: {
    title: "Thank you for your message!",
    message: "I will get back to you as soon as possible.",
    newFormButton: "New Form"
  },
  errorMessage: "Something went wrong. Please try again later."
};

export default contactData;
